"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notifications = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const dated_evidence_1 = require("../../composite/evidence/dated-evidence/dated-evidence");
const evidence_1 = require("../../composite/evidence/evidence");
const empty_component_1 = require("../../utils/empty-component");
const notification_columns_1 = require("./notification-columns");
const notification_context_1 = require("./notification-context");
const notification_fields_1 = require("./notification-fields");
function Notifications() {
    const intl = (0, react_intl_1.useIntl)();
    const { notificationUrl } = (0, react_1.useContext)(notification_context_1.NotificationContext);
    const columns = (0, notification_columns_1.useColumns)();
    const evidence = (0, dated_evidence_1.useDatedEvidence)({
        identifier: 'NOTIFICATIONS',
        apiProps: {
            url: notificationUrl,
        },
        tableProps: {
            columns,
            tableName: intl.formatMessage({
                id: 'EAS_NOTIFICATIONS_TABLE_TITLE',
                defaultMessage: 'Notifikace',
            }),
            showReportButton: false,
            showBulkActionButton: false,
        },
        detailProps: {
            FieldsComponent: notification_fields_1.Fields,
            GeneralFieldsComponent: empty_component_1.EmptyComponent,
            toolbarProps: {
                title: intl.formatMessage({
                    id: 'EAS_NOTIFICATIONS_DETAIL_TITLE',
                    defaultMessage: 'Notifikace',
                }),
                showBtn: lodash_1.stubFalse,
            },
        },
    });
    return react_1.default.createElement(evidence_1.Evidence, { ...evidence });
}
exports.Notifications = Notifications;
//# sourceMappingURL=notifications.js.map